import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";

export default class GreyhoundRacingRacecards extends Component {
  static propTypes = {
    GreyhoundRacingRacecardsForDateContainer: PropTypes.element,
    GreyhoundRacingRacePageContainer: PropTypes.element,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      GreyhoundRacingRacecardsForDateContainer,
      GreyhoundRacingRacePageContainer
    } = this.props;

    return (
      <div className="greyhound-racing-racecards">
        <StandardPage sport="greyhounds" title="Greyhounds racecards">
          <div className="main-layout-left-column">
            {GreyhoundRacingRacecardsForDateContainer || GreyhoundRacingRacePageContainer}
          </div>

          <RightColumn location={location}
                       sport="greyhounds"
                       content={
                         ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingRacecards.js